module.exports = __webpack_public_path__ + "static/media/people-black.8dbccbcc.svg";